<template>
  <a-modal v-model="visible" :title="title" :footer="null" class="preview-modal" :width="840">
    <a-table size="middle" :columns="columns" class="steps_table" :pagination="false" :data-source="data" :row-key="(_, index) => index">
      <template slot="step" slot-scope="text, record">
        <span v-if="record.step" v-html="record.step.replace(/\n/g, '<br>')" />
      </template>
      <template slot="result" slot-scope="text, record">
        <span v-if="record.result" v-html="record.result.replace(/\n/g, '<br>')" />
      </template>
      <span slot="images" slot-scope="text, record">
        <CaseStepImages :data-list.sync="record.images" :is-edit="false" />
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import CaseStepImages from '@/pages/project/case/components/CaseStepImages';

const columns = [
  {
    title: '序号',
    dataIndex: 'number',
    key: 'number',
    align: 'center',
    width: 60,
    customRender: (_text, _row, index) => index + 1
  },
  {
    key: 'step',
    width: '35%',
    title: '操作步骤',
    dataIndex: 'step',
    scopedSlots: { customRender: 'step' }
  },
  {
    width: '35%',
    key: 'result',
    title: '预期结果',
    dataIndex: 'result',
    scopedSlots: { customRender: 'result' }
  },
  {
    width: '30%',
    title: '图片',
    key: 'images',
    dataIndex: 'images',
    scopedSlots: { customRender: 'images' }
  }
];
export default {
  components: { CaseStepImages },
  data() {
    return {
      columns,
      data: [],
      title: null,
      visible: false
    };
  },
  methods: {
    onOpen(data, title = null) {
      this.title = title;
      this.visible = true;
      this.data = data;
    }
  }
};
</script>
<style>
.preview-modal .ant-modal-body {
  min-height: 50vh;
  max-height: 80vh;
  overflow: auto !important;
}
</style>
